#import "../../../../core/schema/fragments/VoucherFull.graphql"

query (
  $nextToken: String
) {
  listVouchers(
    nextToken: $nextToken
  ) {
    items {
      ...VoucherFull
    }
    nextToken
  }
}
